
import 'summernote';

$(document).ready(() => {
    if($('.wysiwyg').length > 0) {
        $('.wysiwyg').summernote({
            styleTags: ['p', 'h1', 'h2', 'h3'],
            toolbar: [
                ['style', ['style']],
                ['color', ['color', 'bold', 'italic', 'underline', 'clear']],
                ['insert', ['link', 'picture', 'video']],
                ['para', ['ul', 'ol']],
            ],
            callbacks : {
                onImageUpload: function(image) {
                    uploadSummerNoteImage(image[0]);
                }
            }
        });
    }

    function uploadSummerNoteImage(image) {
        var data = new FormData();
        data.append("image", image);

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax ({
            data: data,
            type: "POST",
            url: "/partner/dashboard/summernote",
            cache: false,
            contentType: false,
            processData: false,
            success: function(url) {
                $('.wysiwyg').summernote("insertImage", url);
            },
            error: function(data) {
                console.log(data);
            }
        });
    }
});
